import React, {useContext} from "react";
import Introduction from "./Sections/Introduction";
import BlogSection from "./Sections/BlogSection";
import ProjectSection from "./Sections/ProjectSection";
import AboutSection from "./Sections/AboutSection";
import SkillSection from "./Sections/SkillSection";
import ThemeContext from "../store/theme-context";
import ContactSection from "./Sections/ContactSection";

const Home = () => {
    const theme = useContext(ThemeContext);
    return ( 
        <section style={{background: theme.currentTheme.background, color: theme.currentTheme.foreground}}>
            <Introduction/>
            <AboutSection/>
            <SkillSection/>
            <BlogSection/>
            <ProjectSection/>
            <ContactSection/>

        </section>
     );
}
 
export default Home;